import { useScopedSelector } from 'ia-react-core';
import { useContext } from 'react';
import ResourcesContext from '../components/Resource/ResourcesContext';

export interface ResourceState {
  errorHandled: boolean;
  pending: boolean;
  error: unknown;
  attempts: number;
  requestCount: number;
}

export default function useResourceState(resourceName: string): ResourceState {
  const ctx = useContext(ResourcesContext);
  const state: ResourceState = useScopedSelector(resourceName);
  return {
    errorHandled: !!(ctx?.errorsHandled && state?.error),
    ...state,
  };
}
